import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const MaxNumberOfPersons: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = getDefaultClasses('right'),
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='max-number-of-persons'
        propertyName='maxNumberOfPersons'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.maxNumberOfPersons', 'max Number Of Persons')}</span>}
        value={insertionData.maxNumberOfPersons}
        maxLength={4}
        type='tel'
        numericOnly
        errors={validationMessages!.maxNumberOfPersons ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default MaxNumberOfPersons
